<template lang='pug'>
  .banner-section(:class='{ mobile: isMobile }')
    .banner(:class='[{ mobile: isMobile }, country]')
      .search-title-split
        .search-title(v-t='"faq.searchTitle"')
        .search-sub-title(v-t='"faq.searchSubTitle"')
      .search-title-full
        .search-title
          span(v-t='"faq.searchTitle"')
          span(v-t='"faq.searchSubTitle"')

      .search-bar(ref='searchBar')
        form(action='/faqs-search')
          input.search-input(type='text' autocomplete='off' name='q' :value='query' @keyup='updateQuery' :placeholder='$t("faq.searchMessage")' @focus='focusSearchInput')
          a.svg-icon.search-black.search-button(:href='`/faqs-search?q=${query}`')

      transition(name='fade')
        search-results(v-if='focusSearch')
</template>

<i18n>
{
  "lng_en": {
    "faq": {
      "searchTitle": "Hi beautiful, ",
      "searchSubTitle": "how can we help you?",
      "searchMessage": "Search FAQ"
    }
  },
  "lng_id": {
    "faq": {
      "searchTitle": "Hi Cantik, ",
      "searchSubTitle": "ada yang bisa kami bantu?",
      "searchMessage": "Cari FAQ"
    }
  },
  "lng_th": {
    "faq": {
      "searchMessage": "ค้นหา FAQ",
      "searchResults": "ผลของการค้นหา",
      "totalSearchResults": "%{total} พบผลลัพธ์สำหรับ “%{query}”",
      "noSearchResults": "ไม่พบผลลัพธ์สำหรับ “%{query}”"
    }
  },
  "lng_zh": {
    "faq": {
      "searchTitle": "你好，",
      "searchSubTitle": "請問你有甚麼問題",
      "searchMessage": "搜尋常見問題"
    }
  },
  "lng_ko": {
    "faq": {
      "searchTitle": "안녕하세요, 고객님 ",
      "searchSubTitle": "무엇을 도와드릴까요? ",
      "searchMessage": "자주 묻는 질문 검색"
    }
  }
}
</i18n>

<script>
import SearchResults from './search-results.vue'
import { createNamespacedHelpers } from 'vuex'
import debounce from 'lodash/debounce'
const { mapState, mapMutations, mapActions } = createNamespacedHelpers('faq')

export default {
  components: {
    SearchResults
  },

  data () {
    return {
      country: I18n.siteCountryLs || '',
      debounceSearch: debounce(() => {
        this.fetchSearchResults()
      }, 500)
    }
  },

  computed: {
    ...mapState({
      query: state => state.searchQuery,
      focusSearch: state => state.focusSearch,
      results: state => state.results,
      isMobile: () => vueSupport.isMobile
    })
  },

  watch: {
    query () {
      if (this.query.length < 2) {
        this.setResults([])
        return
      }
      // Only start searching after user input has a short pause
      this.setArticlesLoading(true)
      this.debounceSearch()
    }
  },

  created () {
    window.addEventListener('click', this.closeSearch)
  },

  destroyed () {
    window.removeEventListener('click', this.closeSearch)
  },

  methods: {
    ...mapMutations([
      'setSearchQuery',
      'setFocusSearch',
      'setArticlesLoading',
      'setResults'
    ]),

    ...mapActions(['fetchSearchResults']),

    updateQuery (e) {
      this.setSearchQuery(e.target.value)
    },

    focusSearchInput () {
      this.setFocusSearch(true)

      if (this.query.length < 2) { return }
      this.fetchSearchResults()
    },

    closeSearch (e) {
      const el = this.$refs.searchBar
      const target = e.target
      if (el !== target && !el.contains(target)) {
        this.setSearchQuery('')
        this.setFocusSearch(false)
        this.setResults([])
      }
    }
  }
}
</script>

<style lang='scss' scoped>
  .banner-section {
    height: 190px;
    margin-top: 10px;
    margin-bottom: 35px;
  }

  .banner {
    background-image: url('../../assets/images/faq/new-faq-desktop.jpg');
    background-repeat: no-repeat;
    height: 190px;
  }

  .bd, .bn, .jp, .la, .lk, .mm, .pk, .tw, .vn {
    background-image: url('../../assets/images/faq/desktop-banner-globale.jpg');
  }

  .search-title-full {
    display: block;
  }

  .search-title-split {
    display: none;
  }

  .search-title {
    height: 65px;
    text-align: center;
    color: $black;
    font-family: $font-family-sephora-serif;
    font-size: 32px;
    font-weight: 300;
    letter-spacing: 0.85px;
    line-height: 105px;
  }

  .search-bar {
    height: 50px;
    width: 510px;
    display: flex;
    flex-direction: row;
    margin: 30px auto 0;
    border: 1px solid $black;
    border-radius: 1px;
    background-color: $white;
  }

  .search-input {
    float: left;
    width: 450px;
    margin-top: 15px;
    margin-left: 20px;
    font-size: 20px;
    line-height: 24px;
    outline: none;
    border: none;

    &::-webkit-input-placeholder {
      color: $grey-mid;
    }

    &::-moz-placeholder {
      color: $grey-mid;
    }

    &:-ms-input-placeholder {
      color: $grey-mid;
    }
  }

  .search-button {
    width: 30px;
    background-size: 22px;
    margin-top: 5px;
    cursor: pointer;
  }

  @include media-breakpoint-down(lg) {
    .banner {
      background-image: url('../../assets/images/faq/tablet-landscape-banner.jpg');
    }

    .au, .nz {
      background-image: url('../../assets/images/faq/tablet-landscape-banner-aunz.jpg');
    }

    .bd, .bn, .jp, .la, .lk, .mm, .pk, .tw, .vn {
      background-image: url('../../assets/images/faq/tablet-landscape-banner-globale.jpg');
    }
  }

  @include media-breakpoint-down(md) {
    .banner-section {
      margin-top: 0;
      margin-bottom: 35px;
    }

    .banner {
      background-image: url('../../assets/images/faq/tablet-portrait-banner.jpg');
      background-size: contain;
      width: 100%;
      display: block;
    }

    .bd, .bn, .jp, .la, .lk, .mm, .pk, .tw, .vn {
      background-image: url('../../assets/images/faq/tablet-portrait-banner-globale.jpg');
    }

    .search-title-full {
      display: none;
    }

    .search-title-split {
      display: block;
    }

    .search-title {
      line-height: 85px;
    }

    .search-sub-title {
      text-align: center;
      font-family: $font-family-sephora-serif;
      font-size: 20px;
    }

    .search-bar {
      width: 300px;
      margin: 20px auto 0;
    }

    .search-input {
      width: 235px;
    }

    .search-button {
      width: 25px;
    }
  }

  @include media-breakpoint-down(sm) {
    .banner-section.mobile {
      margin-top: 0;
      margin-bottom: 0;
    }

    .banner {
      background-image: url('../../assets/images/faq/mobile-banner.jpg');
      background-size: 100% auto;
      width: 100%;
      display: block;
      left: 0;
      right: 0;
      margin-top: -15px;
      z-index: 2;

      &.mobile {
        position: fixed;
      }
    }
  }
</style>

<style lang='scss'>
  .with-sidebar {
    @include media-breakpoint-down(sm) {
      .banner {
        &.mobile {
          position: absolute;
        }
      }
    }
  }
</style>
